var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e1554331ba0057faa30e8521777f22f4.js').default;export default
        Object.assign({}, scope_0 )
    